import React from "react";

export function SleekSingleColumn() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 97)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 20)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 13)"
            ></rect>
            <rect
                width="10"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 72 13)"
            ></rect>
            <rect
                width="15"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 85 13)"
            ></rect>
            <rect
                width="100"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 78)"
            ></rect>
        </svg>
    );
}

export function BalancedTwoColumns() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 97)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 20)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 13)"
            ></rect>
            <rect
                width="10"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 72 13)"
            ></rect>
            <rect
                width="15"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 85 13)"
            ></rect>
            <rect
                width="49"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 78)"
            ></rect>
            <rect
                width="49"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 54 78)"
            ></rect>
        </svg>
    );
}

export function TwoColumnsWithSearch() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 97)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 20)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 12)"
            ></rect>
            <rect
                width="22.7"
                height="5.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="2.85"
                transform="matrix(1 0 0 -1 77 13.7)"
            ></rect>
            <path
                stroke="#718294"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.3"
                d="M79.95 11.9a.95.95 0 100-1.9.95.95 0 000 1.9zM81 12l-.2-.2"
            ></path>
            <rect
                width="29"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 78)"
            ></rect>
            <rect
                width="69"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 34 78)"
            ></rect>
        </svg>
    );
}
export function ThirtySeventySplitLayout() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 97)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 20)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 12)"
            ></rect>
            <rect
                width="29"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 78)"
            ></rect>
            <rect
                width="69"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 34 78)"
            ></rect>
        </svg>
    );
}

export function SeventyThirtySplitLayout() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 97)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 20)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 12)"
            ></rect>
            <rect
                width="29"
                height="56"
                x="103"
                y="78"
                fill="#fff"
                rx="3"
                transform="rotate(-180 103 78)"
            ></rect>
            <rect
                width="69"
                height="56"
                x="72"
                y="78"
                fill="#fff"
                rx="3"
                transform="rotate(-180 72 78)"
            ></rect>
        </svg>
    );
}

export function GridLayout() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 99)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 92)"
            ></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 20)"
            ></rect>
            <rect
                width="47"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 30 16)"
            ></rect>
            <rect
                width="13"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 47 11)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="26"
                y="32"
                fill="#fff"
                rx="2"
                transform="rotate(-180 26 32)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="26"
                y="44"
                fill="#fff"
                rx="2"
                transform="rotate(-180 26 44)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="26"
                y="56"
                fill="#fff"
                rx="2"
                transform="rotate(-180 26 56)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="26"
                y="68"
                fill="#fff"
                rx="2"
                transform="rotate(-180 26 68)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="26"
                y="80"
                fill="#fff"
                rx="2"
                transform="rotate(-180 26 80)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="52"
                y="32"
                fill="#fff"
                rx="2"
                transform="rotate(-180 52 32)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="52"
                y="44"
                fill="#fff"
                rx="2"
                transform="rotate(-180 52 44)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="52"
                y="56"
                fill="#fff"
                rx="2"
                transform="rotate(-180 52 56)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="52"
                y="68"
                fill="#fff"
                rx="2"
                transform="rotate(-180 52 68)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="52"
                y="80"
                fill="#fff"
                rx="2"
                transform="rotate(-180 52 80)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="78"
                y="32"
                fill="#fff"
                rx="2"
                transform="rotate(-180 78 32)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="78"
                y="44"
                fill="#fff"
                rx="2"
                transform="rotate(-180 78 44)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="78"
                y="56"
                fill="#fff"
                rx="2"
                transform="rotate(-180 78 56)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="78"
                y="68"
                fill="#fff"
                rx="2"
                transform="rotate(-180 78 68)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="78"
                y="80"
                fill="#fff"
                rx="2"
                transform="rotate(-180 78 80)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="104"
                y="32"
                fill="#fff"
                rx="2"
                transform="rotate(-180 104 32)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="104"
                y="44"
                fill="#fff"
                rx="2"
                transform="rotate(-180 104 44)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="104"
                y="56"
                fill="#fff"
                rx="2"
                transform="rotate(-180 104 56)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="104"
                y="68"
                fill="#fff"
                rx="2"
                transform="rotate(-180 104 68)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="104"
                y="80"
                fill="#fff"
                rx="2"
                transform="rotate(-180 104 80)"
            ></rect>
        </svg>
    );
}

export function DashboardLayout() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 97)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 20)"
            ></rect>
            <path
                fill="#0466C8"
                d="M5.672 14v-2.844h.734c.564 0 .991.118 1.282.354.29.234.435.587.435 1.058 0 .461-.137.816-.412 1.063-.274.246-.669.369-1.186.369h-.853zm.45-.383h.429c.36 0 .632-.09.818-.271.186-.183.28-.442.28-.78 0-.345-.098-.602-.294-.771-.195-.17-.496-.256-.904-.256h-.33v2.078zm3.444.072c.192 0 .334-.063.428-.189.094-.128.14-.297.14-.51 0-.208-.048-.375-.146-.502-.096-.126-.239-.19-.427-.19-.194 0-.34.065-.44.192-.099.127-.148.294-.148.504 0 .206.05.373.148.502.1.129.249.194.445.194zm-.06.356c-.156 0-.298-.029-.424-.086a.834.834 0 01-.307-.234 1.086 1.086 0 01-.18-.329 1.252 1.252 0 01.004-.787c.045-.127.107-.24.188-.34a.865.865 0 01.309-.236.981.981 0 01.418-.088c.132 0 .251.029.355.086a.678.678 0 01.25.227v-.262h.428V14h-.436v-.3a.681.681 0 01-.605.346zm2.369 0c-.175 0-.332-.025-.473-.076a1.189 1.189 0 01-.332-.172l.114-.32c.079.06.18.11.3.154.121.043.24.064.356.064.232 0 .348-.085.348-.255a.175.175 0 00-.073-.15 1.265 1.265 0 00-.306-.136l-.188-.064a1.88 1.88 0 01-.217-.086.87.87 0 01-.164-.106.394.394 0 01-.119-.158.605.605 0 01-.037-.222c0-.1.02-.186.06-.26a.455.455 0 01.166-.178.787.787 0 01.233-.098 1.07 1.07 0 01.272-.033c.135 0 .264.017.386.051.123.034.227.079.313.135l-.117.305a1.4 1.4 0 00-.256-.1.992.992 0 00-.284-.045c-.23 0-.345.069-.345.207 0 .063.02.11.06.14.042.032.132.072.272.122l.096.033.101.035c.075.026.137.05.186.072.048.021.097.049.148.082.052.034.092.07.121.11a.612.612 0 01.1.342.61.61 0 01-.065.287.48.48 0 01-.17.19.962.962 0 01-.486.13zM13.066 14v-2.87h.438v1.145a.586.586 0 01.264-.238.823.823 0 01.677-.035.616.616 0 01.22.144.694.694 0 01.132.211c.035.083.06.163.072.243.013.079.02.162.02.25V14h-.438v-1.158c0-.192-.031-.33-.094-.414-.06-.086-.157-.13-.289-.13a.586.586 0 00-.39.15.44.44 0 00-.174.341V14h-.438zm3.407-.31a.46.46 0 00.402-.196c.091-.13.137-.3.137-.508a.814.814 0 00-.14-.494.46.46 0 00-.395-.193.52.52 0 00-.428.197.773.773 0 00-.156.498c0 .202.05.369.152.5.103.13.245.196.428.196zm.07.355a.785.785 0 01-.389-.096.618.618 0 01-.246-.232V14h-.445c.009-.272.014-.45.014-.531V11.13h.437v1.166a.398.398 0 01.068-.107.65.65 0 01.32-.207.865.865 0 01.259-.038c.278 0 .5.095.664.285.164.19.246.438.246.747 0 .316-.09.573-.268.771a.85.85 0 01-.66.297zm2.383 0c-.168 0-.32-.027-.455-.082a.89.89 0 01-.526-.555 1.23 1.23 0 01-.066-.41c0-.2.039-.379.117-.535a.89.89 0 01.358-.377c.161-.094.352-.14.574-.14.169 0 .32.026.453.08.133.053.24.128.324.224a.97.97 0 01.19.334c.044.126.066.266.066.418 0 .144-.023.28-.068.404a1.008 1.008 0 01-.194.332.853.853 0 01-.326.225 1.165 1.165 0 01-.447.082zm-.002-.355c.192 0 .337-.065.433-.194a.805.805 0 00.147-.5.805.805 0 00-.149-.504c-.099-.129-.243-.193-.433-.193s-.335.064-.436.193a.798.798 0 00-.15.504c0 .204.05.371.148.5.1.129.246.194.44.194zm2.474 0c.192 0 .334-.064.428-.19.094-.128.14-.297.14-.51 0-.208-.048-.375-.146-.502-.096-.126-.239-.19-.427-.19-.194 0-.34.065-.44.192-.099.127-.148.294-.148.504 0 .206.05.373.148.502.1.129.249.194.445.194zm-.06.355c-.156 0-.298-.029-.424-.086a.834.834 0 01-.307-.234 1.088 1.088 0 01-.18-.329 1.254 1.254 0 01.004-.787c.045-.127.107-.24.188-.34a.866.866 0 01.309-.236.981.981 0 01.418-.088c.133 0 .251.029.355.086a.678.678 0 01.25.227v-.262h.428V14h-.436v-.3a.681.681 0 01-.605.346zM23 14v-1.504a7.11 7.11 0 00-.023-.416l-.008-.084h.465v.283c.144-.222.315-.334.511-.334a.76.76 0 01.203.03v.384a.712.712 0 00-.234-.039.442.442 0 00-.344.145c-.087.095-.13.231-.13.408V14H23zm2.432-.31c.18 0 .315-.065.406-.194.091-.13.137-.3.137-.508a.83.83 0 00-.14-.496.462.462 0 00-.4-.193.47.47 0 00-.404.193.837.837 0 00-.14.504c0 .204.045.371.136.5a.463.463 0 00.405.194zm-.08.355a.858.858 0 01-.659-.283c-.173-.19-.26-.442-.26-.754 0-.149.021-.287.063-.414.042-.128.101-.24.178-.336a.796.796 0 01.299-.229.961.961 0 01.408-.084.71.71 0 01.369.092.533.533 0 01.213.201v-1.107h.437v2.342c0 .06.005.235.014.527h-.445l-.004-.287a.532.532 0 01-.211.228.716.716 0 01-.402.104z"
            ></path>
            <rect
                width="22.7"
                height="5.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="2.85"
                transform="matrix(1 0 0 -1 77 13.7)"
            ></rect>
            <path
                stroke="#718294"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.3"
                d="M79.95 11.9a.95.95 0 100-1.9.95.95 0 000 1.9zM81 12l-.2-.2"
            ></path>
            <rect
                width="23"
                height="10"
                x="26"
                y="32"
                fill="#fff"
                rx="2"
                transform="rotate(180 26 32)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="52"
                y="32"
                fill="#fff"
                rx="2"
                transform="rotate(180 52 32)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="78"
                y="32"
                fill="#fff"
                rx="2"
                transform="rotate(180 78 32)"
            ></rect>
            <rect
                width="23"
                height="10"
                x="103"
                y="32"
                fill="#fff"
                rx="2"
                transform="rotate(180 103 32)"
            ></rect>
            <rect
                width="29"
                height="44"
                x="103"
                y="78"
                fill="#fff"
                rx="3"
                transform="rotate(-180 103 78)"
            ></rect>
            <rect
                width="69"
                height="44"
                x="72"
                y="78"
                fill="#fff"
                rx="3"
                transform="rotate(-180 72 78)"
            ></rect>
        </svg>
    );
}

// HEADER
export function Banner() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 60)"
            ></rect>
            <path
                fill="#B1B1B6"
                d="M100 45c-1.102 0-2 .898-2 2 0 1.102.898 2 2 2 1.102 0 2-.898 2-2 0-1.102-.898-2-2-2zm.672 2.46a.15.15 0 010 .212.148.148 0 01-.106.044.148.148 0 01-.106-.044l-.46-.46-.46.46a.148.148 0 01-.106.044.148.148 0 01-.106-.044.15.15 0 010-.212l.46-.46-.46-.46a.15.15 0 010-.212.15.15 0 01.212 0l.46.46.46-.46a.15.15 0 01.212 0 .15.15 0 010 .212l-.46.46.46.46z"
            ></path>
            <rect
                width="40"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 9 53)"
            ></rect>
            <rect
                width="16"
                height="7"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 81 55)"
            ></rect>
        </svg>
    );
}

export function PreLoginHeader() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="16"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 60)"
            ></rect>
            <rect
                width="8"
                height="8"
                fill="#E7E8EF"
                rx="2"
                transform="matrix(1 0 0 -1 6 56)"
            ></rect>
            <path
                fill="#718294"
                d="M8.116 53.402l-.004.004a1.237 1.237 0 01-.102-.4c.014.146.052.278.106.396zM9.4 51.676a.476.476 0 100-.952.476.476 0 000 .952z"
            ></path>
            <path
                fill="#718294"
                d="M10.838 50H9.162C8.434 50 8 50.434 8 51.162v1.676c0 .218.038.408.112.568.172.38.54.594 1.05.594h1.676c.728 0 1.162-.434 1.162-1.162v-1.676c0-.728-.434-1.162-1.162-1.162zm.836 2.1a.446.446 0 00-.564 0l-.832.714a.446.446 0 01-.564 0l-.068-.056a.444.444 0 00-.528-.028l-.748.502a1.067 1.067 0 01-.07-.394v-1.676c0-.564.298-.862.862-.862h1.676c.564 0 .862.298.862.862v.96l-.026-.022z"
            ></path>
            <rect
                width="12"
                height="4"
                fill="#E7E8EF"
                rx="2"
                transform="matrix(1 0 0 -1 88 54)"
            ></rect>
            <rect
                width="11.7"
                height="3.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="1.85"
                transform="matrix(1 0 0 -1 74 53.7)"
            ></rect>
            <rect
                width="10"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 27 54)"
            ></rect>
            <rect
                width="10"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 39 54)"
            ></rect>
            <rect
                width="10"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 51 54)"
            ></rect>
        </svg>
    );
}

export function PostLoginHeader() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="78"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 99)"
            ></rect>
            <rect
                width="96"
                height="8"
                fill="#E7E8EF"
                rx="2"
                transform="matrix(1 0 0 -1 5 31)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 7 28)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 19 28)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 31 28)"
            ></rect>
            <rect
                width="100"
                height="16"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 19)"
            ></rect>
            <rect
                width="8"
                height="8"
                fill="#E7E8EF"
                rx="2"
                transform="matrix(1 0 0 -1 6 15)"
            ></rect>
            <path
                fill="#718294"
                d="M8.116 12.402l-.004.004a1.237 1.237 0 01-.102-.4c.014.146.052.278.106.396zM9.4 10.676a.476.476 0 100-.952.476.476 0 000 .952z"
            ></path>
            <path
                fill="#718294"
                d="M10.838 9H9.162C8.434 9 8 9.434 8 10.162v1.676c0 .218.038.408.112.568.172.38.54.594 1.05.594h1.676c.728 0 1.162-.434 1.162-1.162v-1.676C12 9.434 11.566 9 10.838 9zm.836 2.1a.446.446 0 00-.564 0l-.832.714a.446.446 0 01-.564 0l-.068-.056a.444.444 0 00-.528-.028l-.748.502a1.067 1.067 0 01-.07-.394v-1.676c0-.564.298-.862.862-.862h1.676c.564 0 .862.298.862.862v.96l-.026-.022z"
            ></path>
            <rect
                width="4"
                height="4"
                fill="#E7E8EF"
                rx="2"
                transform="matrix(1 0 0 -1 96 13)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 60 12)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 72 12)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 84 12)"
            ></rect>
            <rect
                width="22.8"
                height="5.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.2"
                rx="2.9"
                transform="matrix(1 0 0 -1 16 13.8)"
            ></rect>
            <path
                stroke="#718294"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.3"
                d="M18.95 11.9a.95.95 0 100-1.9.95.95 0 000 1.9zM20 12l-.2-.2"
            ></path>
        </svg>
    );
}

export function BasicSectionHeader() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 60)"
            ></rect>
            <path
                fill="#0466C8"
                d="M7.28 51v-2.46h-.89v-.384h2.237v.383h-.898V51h-.45zm1.679-2.453v-.39h.426v.39h-.426zM8.957 51v-2.004h.428V51h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V51h-.435zm1.393-1.227h1.035a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.329 0-.589-.096-.78-.287-.192-.192-.287-.444-.287-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.537-.145.93.93 0 01.397.08.678.678 0 01.277.221c.07.094.123.203.159.326.035.123.052.258.052.406a.462.462 0 01-.01.09h-1.425c.008.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect
                width="30"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 56)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#DDFFEA"
                rx="1"
                transform="matrix(1 0 0 -1 20 51)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#FFF5CF"
                rx="1"
                transform="matrix(1 0 0 -1 31 51)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#FFE6E6"
                rx="1"
                transform="matrix(1 0 0 -1 42 51)"
            ></rect>
            <rect
                width="12"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 88 53)"
            ></rect>
            <rect
                width="11.7"
                height="3.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="0.85"
                transform="matrix(1 0 0 -1 74 52.7)"
            ></rect>
        </svg>
    );
}

export function SectionHeaderWithAction() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 60)"
            ></rect>
            <path
                fill="#0466C8"
                d="M7.28 50v-2.46h-.89v-.384h2.237v.383h-.898V50h-.45zm1.679-2.453v-.39h.426v.39h-.426zM8.957 50v-2.004h.428V50h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V50h-.435zm1.393-1.227h1.035a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.329 0-.589-.096-.78-.287-.192-.192-.287-.444-.287-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.537-.145.93.93 0 01.397.08.678.678 0 01.277.221c.07.094.123.203.159.326.035.123.052.258.052.406a.462.462 0 01-.01.09h-1.425c.008.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect
                width="50"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 54)"
            ></rect>
            <rect
                width="28"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 57)"
            ></rect>
            <rect
                width="12"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 88 53)"
            ></rect>
            <rect
                width="11.7"
                height="3.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="0.85"
                transform="matrix(1 0 0 -1 74 52.7)"
            ></rect>
        </svg>
    );
}

// FORM
export function ContactForm() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 12)"
            ></rect>
            <rect
                width="29"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 78)"
            ></rect>
            <rect
                width="25"
                height="48"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 5 74)"
            ></rect>
            <rect
                width="24.8"
                height="47.8"
                x="0.1"
                y="-0.1"
                stroke="#A8ABBB"
                strokeDasharray="0.4 0.4"
                strokeOpacity="0.41"
                strokeWidth="0.2"
                rx="2.9"
                transform="matrix(1 0 0 -1 5 73.8)"
            ></rect>
            <path
                stroke="#A8ABBB"
                strokeDasharray="0.5 0.5"
                strokeOpacity="0.4"
                strokeWidth="0.2"
                d="M7 72.5L28 28M28 72.5L7 28"
            ></path>
            <rect
                width="69"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 34 78)"
            ></rect>
            <rect
                width="40"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 37 27)"
            ></rect>
            <rect
                width="20"
                height="1"
                fill="#E7E8EF"
                rx="0.5"
                transform="matrix(1 0 0 -1 37 29)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 37 37)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 37 44)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 37 51)"
            ></rect>
            <rect
                width="29.7"
                height="3.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="0.85"
                transform="matrix(1 0 0 -1 37 60.7)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 70 37)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 70 44)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 70 61)"
            ></rect>
            <rect width="9" height="9" x="13" y="45" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M14.674 51.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM16.6 49.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M18.757 46.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V48.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function AddressForm() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="17"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 20)"
            ></rect>
            <path
                fill="#0466C8"
                d="M7.28 10V7.54h-.89v-.384h2.237v.383h-.898V10h-.45zm1.679-2.453v-.39h.426v.39h-.426zM8.957 10V7.996h.428V10h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.631.631 0 01-.246-.104.429.429 0 01-.156-.219 1.198 1.198 0 01-.047-.367V8.29h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.106.046.026.1.042.164.048.064.007.157.01.28.01v.336zm.477.002V7.13h.435V10h-.435zm1.393-1.227h1.035a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.329 0-.589-.096-.78-.287-.192-.192-.287-.444-.287-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.537-.145.93.93 0 01.397.08.678.678 0 01.277.221c.07.094.123.203.159.326.035.123.052.258.052.407a.461.461 0 01-.01.09h-1.425c.008.205.07.36.185.464a.658.658 0 00.457.156c.228 0 .438-.072.63-.218l.122.32a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect
                width="50"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 14)"
            ></rect>
            <rect
                width="28"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 17)"
            ></rect>
            <rect
                width="12"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 88 13)"
            ></rect>
            <rect
                width="11.7"
                height="3.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="0.85"
                transform="matrix(1 0 0 -1 74 12.7)"
            ></rect>
            <rect
                width="100"
                height="78"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 99)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 5 29)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 5 36)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 5 43)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 5 50)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 38 29)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 38 36)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 38 43)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 38 50)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 29)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 36)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 43)"
            ></rect>
        </svg>
    );
}

export function LoginForm() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 12)"
            ></rect>
            <rect
                width="48"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 78)"
            ></rect>
            <rect
                width="44"
                height="48"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 5 74)"
            ></rect>
            <rect
                width="43.8"
                height="47.8"
                x="0.1"
                y="-0.1"
                stroke="#A8ABBB"
                strokeDasharray="0.4 0.4"
                strokeOpacity="0.41"
                strokeWidth="0.2"
                rx="2.9"
                transform="matrix(1 0 0 -1 5 73.8)"
            ></rect>
            <path
                stroke="#A8ABBB"
                strokeDasharray="0.5 0.5"
                strokeOpacity="0.4"
                strokeWidth="0.2"
                d="M7 73l40-45M47 73L7 28"
            ></path>
            <rect width="9" height="9" x="23" y="46" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M24.674 52.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM26.6 50.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M28.757 47.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V49.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
            <rect
                width="50"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 53 78)"
            ></rect>
            <rect width="9" height="9" x="74" y="29" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M75.674 35.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM77.6 33.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M79.757 30.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V32.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
            <rect
                width="33"
                height="2"
                x="62"
                y="45"
                fill="#E7E8EF"
                rx="1"
            ></rect>
            <rect
                width="20"
                height="2"
                x="69"
                y="41"
                fill="#E7E8EF"
                rx="1"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 55)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 61)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 64 69)"
            ></rect>
        </svg>
    );
}

// CARD
export function ReviewCard() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="51"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 77)"
            ></rect>
            <rect
                width="50"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 33)"
            ></rect>
            <rect
                width="94"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 49)"
            ></rect>
            <rect
                width="64"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 53)"
            ></rect>
            <rect
                width="94"
                height="16"
                fill="#F5F6FB"
                rx="1"
                transform="matrix(1 0 0 -1 6 74)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 88 33)"
            ></rect>
            <path
                fill="#00C969"
                d="M8.31 36.585a.2.2 0 01.38 0l.326 1.004a.2.2 0 00.19.139h1.056a.2.2 0 01.118.361l-.854.62a.2.2 0 00-.073.224l.326 1.004a.2.2 0 01-.308.224l-.853-.62a.2.2 0 00-.236 0l-.853.62a.2.2 0 01-.308-.224l.326-1.004a.2.2 0 00-.073-.223l-.854-.62a.2.2 0 01.118-.363h1.055a.2.2 0 00.19-.138l.327-1.004zM13.31 36.585a.2.2 0 01.38 0l.326 1.004a.2.2 0 00.19.139h1.056a.2.2 0 01.118.361l-.854.62a.2.2 0 00-.073.224l.326 1.004a.2.2 0 01-.307.224l-.854-.62a.2.2 0 00-.236 0l-.854.62a.2.2 0 01-.307-.224l.326-1.004a.2.2 0 00-.073-.223l-.854-.62a.2.2 0 01.118-.363h1.055a.2.2 0 00.19-.138l.327-1.004zM18.31 36.585a.2.2 0 01.38 0l.326 1.004a.2.2 0 00.19.139h1.056a.2.2 0 01.118.361l-.854.62a.2.2 0 00-.073.224l.326 1.004a.2.2 0 01-.308.224l-.853-.62a.2.2 0 00-.236 0l-.854.62a.2.2 0 01-.307-.224l.326-1.004a.2.2 0 00-.073-.223l-.854-.62a.2.2 0 01.118-.363h1.055a.2.2 0 00.19-.138l.327-1.004zM23.31 36.585a.2.2 0 01.38 0l.326 1.004a.2.2 0 00.19.139h1.056a.2.2 0 01.118.361l-.854.62a.2.2 0 00-.073.224l.326 1.004a.2.2 0 01-.308.224l-.853-.62a.2.2 0 00-.236 0l-.854.62a.2.2 0 01-.307-.224l.326-1.004a.2.2 0 00-.073-.223l-.854-.62a.2.2 0 01.118-.363h1.055a.2.2 0 00.19-.138l.327-1.004z"
            ></path>
            <path
                fill="#E7E8EF"
                d="M28.31 36.585a.2.2 0 01.38 0l.326 1.004a.2.2 0 00.19.139h1.056a.2.2 0 01.118.361l-.854.62a.2.2 0 00-.073.224l.326 1.004a.2.2 0 01-.308.224l-.853-.62a.2.2 0 00-.236 0l-.854.62a.2.2 0 01-.307-.224l.326-1.004a.2.2 0 00-.073-.223l-.854-.62a.2.2 0 01.118-.363h1.055a.2.2 0 00.19-.138l.327-1.004z"
            ></path>
            <rect
                width="90"
                height="2"
                fill="#718294"
                rx="1"
                transform="matrix(1 0 0 -1 8 64)"
            ></rect>
            <rect
                width="61.277"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 8 68)"
            ></rect>
        </svg>
    );
}

export function SummaryList() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="24"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 63)"
            ></rect>
            <path
                fill="#0466C8"
                d="M19.28 46v-2.46h-.89v-.384h2.237v.383h-.898V46h-.45zm1.679-2.453v-.39h.426v.39h-.426zM20.957 46v-2.004h.428V46h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.547v.293h-.547v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V46h-.435zm1.392-1.227h1.036a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.328 0-.588-.096-.78-.287-.19-.192-.286-.444-.286-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.537-.145.93.93 0 01.397.08.678.678 0 01.277.221c.07.094.123.203.159.326.035.123.052.258.052.406a.462.462 0 01-.01.09h-1.425c.008.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 18 50)"
            ></rect>
            <rect
                width="90"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 8 55)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 8 61)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 61)"
            ></rect>
            <rect width="9" height="9" x="6" y="43" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M7.674 49.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM9.6 47.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M11.757 44.5H9.243c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V46.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function BlogCard() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="66"
                height="54"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 21 78)"
            ></rect>
            <rect
                width="62"
                height="28"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 23 54)"
            ></rect>
            <rect
                width="61.8"
                height="27.8"
                x="0.1"
                y="-0.1"
                stroke="#A8ABBB"
                strokeDasharray="0.4 0.4"
                strokeOpacity="0.41"
                strokeWidth="0.2"
                rx="2.9"
                transform="matrix(1 0 0 -1 23 53.8)"
            ></rect>
            <path
                stroke="#A8ABBB"
                strokeDasharray="0.5 0.5"
                strokeOpacity="0.4"
                strokeWidth="0.2"
                d="M25.818 53.417l56.364-26.25M82.182 53.417l-56.364-26.25"
            ></path>
            <rect width="9" height="9" x="50" y="36" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M51.675 42.604l-.006.006a1.856 1.856 0 01-.153-.6c.02.22.078.417.159.594zM53.6 40.013a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M55.757 37.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V39.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 23 60)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 23 65)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 23 68)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 23 71)"
            ></rect>
            <rect
                width="47"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 23 74)"
            ></rect>
        </svg>
    );
}

export function OrderSummary() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="66"
                height="89"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 20 96)"
            ></rect>
            <rect
                width="62"
                height="7"
                fill="#E7E8EF"
                rx="2"
                transform="matrix(1 0 0 -1 22 16)"
            ></rect>
            <path
                fill="#000"
                d="M39.798 14.032c-.264 0-.493-.059-.688-.176a1.171 1.171 0 01-.452-.504 1.807 1.807 0 01-.156-.776c0-.299.052-.557.156-.776.104-.219.253-.387.448-.504.195-.117.425-.176.692-.176.267 0 .497.059.692.176.195.117.344.285.448.504.104.219.156.476.156.772 0 .299-.053.557-.16.776a1.172 1.172 0 01-.448.508 1.308 1.308 0 01-.688.176zm0-.28c.301 0 .536-.103.704-.308.168-.205.252-.496.252-.872s-.084-.665-.252-.868c-.165-.203-.4-.304-.704-.304-.304 0-.54.103-.708.308-.168.203-.252.49-.252.864 0 .376.084.667.252.872.168.205.404.308.708.308zm2.794-1.812c.066 0 .128.008.184.024l-.008.296a.645.645 0 00-.212-.032c-.195 0-.34.061-.436.184a.695.695 0 00-.14.44V14h-.324v-1.448c0-.208-.01-.396-.032-.564h.308l.032.372a.612.612 0 01.244-.312.695.695 0 01.384-.108zm2.246-.884V14h-.32v-.364a.646.646 0 01-.268.292.82.82 0 01-.412.1.842.842 0 01-.468-.132.883.883 0 01-.312-.368 1.291 1.291 0 01-.112-.552c0-.208.036-.39.108-.544a.846.846 0 01.316-.364.862.862 0 01.468-.128c.157 0 .295.035.412.104a.634.634 0 01.264.284v-1.272h.324zm-.936 2.704a.55.55 0 00.456-.2c.107-.136.16-.328.16-.576 0-.245-.053-.435-.16-.568a.546.546 0 00-.456-.204.573.573 0 00-.464.2c-.11.133-.164.321-.164.564 0 .248.055.441.164.58a.568.568 0 00.464.204zm3.246-.776h-1.476c.003.256.062.45.176.58.118.13.287.196.508.196.235 0 .451-.079.648-.236l.108.236a.935.935 0 01-.34.196 1.253 1.253 0 01-.42.072c-.314 0-.561-.092-.74-.276-.178-.187-.268-.441-.268-.764 0-.205.04-.387.12-.544a.892.892 0 01.828-.504c.267 0 .476.088.628.264.152.173.228.413.228.72v.06zm-.852-.792a.574.574 0 00-.412.152.741.741 0 00-.2.428h1.172c-.016-.19-.072-.333-.168-.432a.513.513 0 00-.392-.148zm2.28-.252c.067 0 .128.008.184.024l-.008.296a.645.645 0 00-.212-.032c-.194 0-.34.061-.436.184a.695.695 0 00-.14.44V14h-.324v-1.448c0-.208-.01-.396-.032-.564h.308l.032.372a.612.612 0 01.244-.312.695.695 0 01.384-.108zm2.5 2.092c-.445 0-.8-.12-1.064-.36l.124-.252c.142.12.286.205.432.256.147.05.318.076.512.076.23 0 .406-.044.528-.132a.442.442 0 00.188-.38.306.306 0 00-.092-.232.592.592 0 00-.236-.144 3.467 3.467 0 00-.388-.108 3.583 3.583 0 01-.54-.156.852.852 0 01-.344-.24.632.632 0 01-.132-.416c0-.163.043-.305.128-.428a.837.837 0 01.36-.292c.158-.07.34-.104.548-.104.198 0 .382.03.552.092.171.061.315.15.432.268l-.128.252a1.4 1.4 0 00-.408-.252 1.217 1.217 0 00-.448-.08c-.221 0-.394.048-.52.144a.457.457 0 00-.188.388c0 .144.055.252.164.324.11.072.278.135.504.188.246.059.438.113.576.164a.833.833 0 01.352.224c.094.099.14.23.14.396 0 .16-.042.301-.128.424a.828.828 0 01-.368.28c-.157.067-.342.1-.556.1zm3.233-2.044V14h-.316v-.348a.663.663 0 01-.269.28.782.782 0 01-.387.096c-.238 0-.418-.067-.54-.2-.123-.133-.184-.33-.184-.592v-1.248h.324v1.24c0 .181.037.315.111.4.075.085.188.128.34.128a.57.57 0 00.433-.172.648.648 0 00.163-.46v-1.136h.325zm2.856-.048c.445 0 .668.265.668.796V14h-.324v-1.248c0-.19-.033-.327-.1-.412-.064-.085-.17-.128-.316-.128a.493.493 0 00-.4.172c-.096.115-.144.27-.144.468V14h-.324v-1.248c0-.187-.033-.323-.1-.408-.067-.088-.173-.132-.32-.132a.505.505 0 00-.404.172c-.096.115-.144.27-.144.468V14h-.324v-1.448c0-.208-.01-.396-.032-.564h.308l.032.352a.647.647 0 01.248-.296.722.722 0 01.388-.104c.16 0 .29.032.392.096a.56.56 0 01.224.296.687.687 0 01.268-.284.77.77 0 01.404-.108zm3.516 0c.445 0 .668.265.668.796V14h-.324v-1.248c0-.19-.034-.327-.1-.412-.064-.085-.17-.128-.316-.128a.493.493 0 00-.4.172c-.096.115-.144.27-.144.468V14h-.324v-1.248c0-.187-.034-.323-.1-.408-.067-.088-.174-.132-.32-.132a.505.505 0 00-.404.172c-.096.115-.144.27-.144.468V14h-.324v-1.448c0-.208-.01-.396-.032-.564h.308l.032.352a.647.647 0 01.248-.296.722.722 0 01.388-.104c.16 0 .29.032.392.096a.559.559 0 01.224.296.688.688 0 01.268-.284.77.77 0 01.404-.108zm3.055.048V14h-.32v-.364a.646.646 0 01-.268.292.82.82 0 01-.412.1.87.87 0 01-.472-.128.86.86 0 01-.312-.36 1.305 1.305 0 01-.108-.548c0-.208.038-.39.112-.548a.878.878 0 01.312-.372.842.842 0 01.468-.132c.158 0 .295.035.412.104.118.07.207.167.268.292v-.348h.32zM62.8 13.76c.198 0 .35-.067.456-.2.107-.136.16-.328.16-.576 0-.248-.053-.439-.16-.572-.106-.133-.258-.2-.456-.2a.564.564 0 00-.464.208c-.109.136-.164.327-.164.572 0 .245.055.435.164.568.11.133.264.2.464.2zm2.499-1.82c.066 0 .128.008.184.024l-.008.296a.645.645 0 00-.212-.032c-.195 0-.34.061-.436.184a.695.695 0 00-.14.44V14h-.324v-1.448c0-.208-.01-.396-.032-.564h.308l.032.372a.612.612 0 01.244-.312.695.695 0 01.384-.108zm2.402.048l-.94 2.196c-.099.23-.223.397-.372.504-.15.107-.333.18-.552.22l-.068-.252c.19-.043.332-.1.428-.172a.748.748 0 00.244-.324l.08-.18-.852-1.992h.34l.68 1.66.688-1.66h.324z"
            ></path>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 22)"
            ></rect>
            <rect
                width="22"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 27)"
            ></rect>
            <rect
                width="16"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 32)"
            ></rect>
            <rect
                width="26"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 37)"
            ></rect>
            <rect
                width="21"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 42)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 22)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 27)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 32)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 37)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 42)"
            ></rect>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 61)"
            ></rect>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 74)"
            ></rect>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 65)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 61)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 74)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#FFD9D4"
                rx="1"
                transform="matrix(1 0 0 -1 71 65)"
            ></rect>
            <rect
                width="61.7"
                height="7.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#0466C8"
                strokeWidth="0.3"
                rx="0.85"
                transform="matrix(1 0 0 -1 22 55.7)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 25 53)"
            ></rect>
            <rect
                width="13"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 68 53)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 83)"
            ></rect>
            <rect
                width="47"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 86)"
            ></rect>
            <path
                stroke="#E7E8EF"
                strokeDasharray="0.4 0.4"
                strokeWidth="0.2"
                d="M22 68.9L84 68.9"
            ></path>
            <path
                stroke="#E7E8EF"
                strokeDasharray="0.4 0.4"
                strokeWidth="0.2"
                d="M22 76.9L84 76.9"
            ></path>
        </svg>
    );
}

export function ProfitInformation() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="28"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 65)"
            ></rect>
            <path
                fill="#0466C8"
                d="M7.213 53.494a.601.601 0 00-.309.111.295.295 0 00-.115.247c0 .115.027.202.08.26.054.057.168.116.344.179v-.797zm.18-.389c.205.01.37.04.494.094.125.052.236.126.334.22l-.23.302c-.15-.142-.348-.219-.598-.23v.857a5.202 5.202 0 00.11.037c.287.097.485.209.595.334.109.123.164.299.164.525 0 .126-.023.24-.069.34a.63.63 0 01-.191.242.98.98 0 01-.275.149 1.319 1.319 0 01-.334.066v.371h-.18v-.367a1.665 1.665 0 01-.54-.102 1.071 1.071 0 01-.376-.222l.195-.324c.08.065.188.124.326.177.138.052.27.08.395.086v-.922l-.156-.05a1.948 1.948 0 01-.418-.184.7.7 0 01-.243-.256.776.776 0 01-.085-.379c0-.236.083-.42.25-.55.168-.132.385-.203.652-.214v-.285h.18v.285zm0 2.545c.261-.037.392-.175.392-.412a.585.585 0 00-.014-.138.29.29 0 00-.054-.108.386.386 0 00-.12-.1c-.051-.03-.12-.06-.204-.091v.85zm3.398-2.543c.26 0 .47.08.63.239.162.157.243.375.243.652a1.072 1.072 0 01-.158.563 2.245 2.245 0 01-.166.234c-.057.07-.13.151-.217.242l-.57.592h1.095V56h-1.644v-.338l.834-.89a2.05 2.05 0 00.303-.391.72.72 0 00.09-.352c0-.174-.043-.308-.127-.4a.445.445 0 00-.348-.14.862.862 0 00-.238.033 1.168 1.168 0 00-.21.072 1.06 1.06 0 00-.087.04.967.967 0 00-.164.096l-.014.008-.147-.353a.391.391 0 01.041-.03c.02-.013.06-.035.12-.066a1.435 1.435 0 01.435-.15c.1-.021.199-.032.299-.032zm2.461 2.938c-.116 0-.227-.01-.334-.03a1.283 1.283 0 01-.271-.074 6.11 6.11 0 01-.157-.07 1.822 1.822 0 01-.084-.049l-.004-.002.135-.342c.242.122.46.182.654.182.18 0 .32-.042.42-.127a.43.43 0 00.153-.35.39.39 0 00-.196-.359c-.128-.08-.308-.119-.539-.119h-.043l-.129.004-.003-.38h.132c.249 0 .428-.036.537-.106.11-.07.165-.195.165-.373a.285.285 0 00-.079-.202.432.432 0 00-.191-.12.752.752 0 00-.246-.04c-.072 0-.14.007-.203.02a.695.695 0 00-.178.058 1.4 1.4 0 00-.225.133l-.017.012-.201-.314c.134-.105.265-.18.392-.225a1.49 1.49 0 01.49-.069c.118 0 .23.016.336.047a.985.985 0 01.29.137.66.66 0 01.283.555.712.712 0 01-.135.43.601.601 0 01-.393.234.714.714 0 01.436.242.68.68 0 01.158.453c0 .17-.044.321-.133.451a.827.827 0 01-.345.295 1.134 1.134 0 01-.475.098zm2.445-2.938c.26 0 .47.08.631.239.162.157.242.375.242.652a1.069 1.069 0 01-.158.563 2.244 2.244 0 01-.166.234c-.057.07-.13.151-.217.242l-.57.592h1.096V56H14.91v-.338l.834-.89c.142-.152.243-.282.303-.391a.72.72 0 00.09-.352c0-.174-.043-.308-.127-.4a.445.445 0 00-.348-.14.868.868 0 00-.238.033 1.166 1.166 0 00-.21.072c-.03.013-.06.026-.087.04a.97.97 0 00-.164.096l-.014.008-.146-.353a1.51 1.51 0 01.16-.096 1.434 1.434 0 01.435-.15c.1-.021.199-.032.3-.032zM17.223 56v-.494h.523V56h-.523zm2.04.045a.816.816 0 01-.54-.188c-.15-.126-.262-.3-.336-.521a2.442 2.442 0 01-.112-.776c0-.46.085-.819.254-1.074.17-.255.417-.383.739-.383.213 0 .393.061.54.182.148.12.257.288.329.504.071.216.107.473.107.771 0 .297-.036.556-.107.776-.072.22-.182.393-.33.52a.81.81 0 01-.543.189zm.008-.385c.34 0 .51-.366.51-1.097 0-.152-.009-.288-.027-.41a1.626 1.626 0 00-.082-.34.536.536 0 00-.16-.239.363.363 0 00-.242-.086.391.391 0 00-.252.086.571.571 0 00-.166.239c-.04.101-.069.214-.088.337-.019.124-.028.26-.028.41 0 .734.179 1.1.535 1.1zm2.397-1.058c.159 0 .287-.05.385-.149.097-.1.146-.24.146-.422a.573.573 0 00-.135-.384.462.462 0 00-.37-.159.479.479 0 00-.376.155.581.581 0 00-.138.404c0 .165.04.3.123.402.082.102.203.153.365.153zm-.084 1.445c-.228 0-.468-.063-.72-.19l.155-.363c.18.11.357.166.532.166a.587.587 0 00.478-.226c.123-.153.184-.379.184-.678v-.074c-.119.195-.317.293-.594.293-.272 0-.489-.085-.65-.254-.162-.17-.242-.39-.242-.664 0-.18.037-.342.113-.485a.844.844 0 01.334-.342c.147-.084.317-.127.51-.127.316 0 .557.119.724.356.168.236.252.58.252 1.035 0 .484-.096.865-.287 1.14a.91.91 0 01-.789.413z"
            ></path>
            <rect
                width="10"
                height="2"
                fill="#C1FFDA"
                rx="1"
                transform="matrix(1 0 0 -1 26 55)"
            ></rect>
            <rect
                width="94"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 62)"
            ></rect>
            <rect width="9" height="9" x="6" y="40" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M7.674 46.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM9.6 44.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M11.757 41.5H9.243c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V43.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 19 46)"
            ></rect>
        </svg>
    );
}

export function LossInformation() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="28"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 65)"
            ></rect>
            <path
                fill="#0466C8"
                d="M8.44 53.494a.601.601 0 00-.31.111.295.295 0 00-.114.247c0 .115.026.202.08.26.053.057.168.116.343.179v-.797zm.18-.389c.205.01.37.04.493.094.125.052.237.126.334.22l-.23.302c-.149-.142-.348-.219-.598-.23v.857a5.168 5.168 0 00.11.037c.287.097.486.209.595.334.11.123.164.299.164.525 0 .126-.023.24-.068.34a.63.63 0 01-.191.242.98.98 0 01-.276.149 1.319 1.319 0 01-.334.066v.371h-.18v-.367a1.665 1.665 0 01-.539-.102 1.071 1.071 0 01-.377-.222l.196-.324c.08.065.188.124.326.177.138.052.27.08.394.086v-.922l-.156-.05a1.948 1.948 0 01-.418-.184.7.7 0 01-.242-.256.776.776 0 01-.086-.379c0-.236.083-.42.25-.55.168-.132.386-.203.652-.214v-.285h.18v.285zm0 2.545c.26-.037.392-.175.392-.412a.586.586 0 00-.014-.138.29.29 0 00-.055-.108.386.386 0 00-.119-.1c-.052-.03-.12-.06-.205-.091v.85zm3.398-2.543c.259 0 .469.08.63.239.162.157.243.375.243.652a1.073 1.073 0 01-.158.563 2.244 2.244 0 01-.167.234c-.057.07-.13.151-.216.242l-.57.592h1.095V56H11.23v-.338l.835-.89a2.05 2.05 0 00.302-.391.72.72 0 00.09-.352c0-.174-.042-.308-.127-.4a.445.445 0 00-.348-.14.786.786 0 00-.12.009 1.166 1.166 0 00-.326.096 1.06 1.06 0 00-.089.04.97.97 0 00-.164.096l-.013.008-.147-.353a1.51 1.51 0 01.16-.096 1.435 1.435 0 01.436-.15c.099-.021.198-.032.299-.032zm2.46 2.938c-.115 0-.227-.01-.333-.03a1.287 1.287 0 01-.272-.074 5.9 5.9 0 01-.156-.07 1.822 1.822 0 01-.084-.049l-.004-.002.135-.342c.242.122.46.182.654.182.18 0 .32-.042.42-.127a.43.43 0 00.152-.35.39.39 0 00-.195-.359c-.129-.08-.309-.119-.54-.119h-.042l-.129.004-.004-.38h.133c.249 0 .428-.036.537-.106.11-.07.164-.195.164-.373a.285.285 0 00-.078-.202.431.431 0 00-.191-.12.751.751 0 00-.247-.04c-.071 0-.139.007-.203.02a.696.696 0 00-.177.058 1.384 1.384 0 00-.225.133l-.018.012-.2-.314c.133-.105.264-.18.392-.225a1.49 1.49 0 01.49-.069c.117 0 .23.016.336.047a.984.984 0 01.289.137.66.66 0 01.283.555.712.712 0 01-.135.43.601.601 0 01-.392.234.713.713 0 01.435.242.68.68 0 01.159.453c0 .17-.045.321-.133.451a.826.826 0 01-.346.295 1.133 1.133 0 01-.474.098zM15.997 56v-.494h.524V56h-.524zm2.041.045a.817.817 0 01-.54-.188c-.15-.126-.263-.3-.337-.521a2.439 2.439 0 01-.111-.776c0-.46.085-.819.254-1.074.17-.255.416-.383.738-.383.214 0 .394.061.541.182.147.12.256.288.328.504.072.216.108.473.108.771 0 .297-.036.556-.108.776-.072.22-.181.393-.33.52a.81.81 0 01-.543.189zm.008-.385c.34 0 .51-.366.51-1.097 0-.152-.01-.288-.028-.41a1.62 1.62 0 00-.082-.34.535.535 0 00-.16-.239.363.363 0 00-.242-.086.391.391 0 00-.252.086.572.572 0 00-.166.239c-.04.101-.068.214-.088.337a2.83 2.83 0 00-.027.41c0 .734.178 1.1.535 1.1zm2.396-1.058c.16 0 .288-.05.385-.149.098-.1.147-.24.147-.422a.573.573 0 00-.135-.384.462.462 0 00-.371-.159.479.479 0 00-.375.155.581.581 0 00-.139.404c0 .165.041.3.123.402.082.102.204.153.365.153zm-.084 1.445c-.227 0-.468-.063-.72-.19l.156-.363c.18.11.357.166.531.166a.587.587 0 00.479-.226c.122-.153.183-.379.183-.678v-.074c-.118.195-.316.293-.593.293-.273 0-.49-.085-.65-.254-.162-.17-.243-.39-.243-.664 0-.18.038-.342.113-.485a.842.842 0 01.334-.342c.147-.084.317-.127.51-.127.316 0 .558.119.725.356.168.236.252.58.252 1.035 0 .484-.096.865-.288 1.14a.91.91 0 01-.789.413z"
            ></path>
            <rect
                width="10"
                height="2"
                fill="#FFD9D4"
                rx="1"
                transform="matrix(1 0 0 -1 26 55)"
            ></rect>
            <rect
                width="94"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 62)"
            ></rect>
            <rect width="9" height="9" x="6" y="40" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M7.674 46.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM9.6 44.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M11.757 41.5H9.243c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V43.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 19 46)"
            ></rect>
        </svg>
    );
}

// MODAL
export function ConfirmationModalForDeletion() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="75"
                height="69"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 16 88)"
            ></rect>
            <rect
                width="12"
                height="4"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 76 85)"
            ></rect>
            <rect
                width="11.7"
                height="3.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="0.85"
                transform="matrix(1 0 0 -1 62 84.7)"
            ></rect>
            <path
                fill="#0466C8"
                d="M32.28 28v-2.46h-.89v-.384h2.237v.383h-.899V28h-.449zm1.679-2.453v-.39h.426v.39h-.426zM33.957 28v-2.004h.428V28h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.146.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V28h-.435zm1.392-1.227h1.036a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.328 0-.588-.096-.78-.287-.19-.192-.286-.444-.286-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.538-.145.93.93 0 01.396.08.678.678 0 01.277.221c.07.094.123.203.158.326.036.123.053.258.053.407a.462.462 0 01-.01.09h-1.425c.008.205.07.36.185.464a.658.658 0 00.457.156c.228 0 .438-.073.63-.218l.122.32a1.27 1.27 0 01-.785.254z"
            ></path>
            <path
                fill="#E7E8EF"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                d="M19.1 73c0 1.05.85 1.9 1.9 1.9h21.9V39.1H21a1.9 1.9 0 00-1.9 1.9v32z"
            ></path>
            <rect
                width="20"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 21 46)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 21 54)"
            ></rect>
            <rect
                width="18"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 21 62)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 21 69)"
            ></rect>
            <mask id="path-11-inside-1_13410_9140" fill="#fff">
                <path d="M43 75h43a2 2 0 002-2V41a2 2 0 00-2-2H43v36z"></path>
            </mask>
            <path
                fill="#fff"
                d="M43 75h43a2 2 0 002-2V41a2 2 0 00-2-2H43v36z"
            ></path>
            <path
                fill="#E7E8EF"
                d="M43 75.2h43a2.2 2.2 0 002.2-2.2h-.4a1.8 1.8 0 01-1.8 1.8H43v.4zM88.2 41a2.2 2.2 0 00-2.2-2.2H43v.4h43a1.8 1.8 0 011.8 1.8h.4zM43 39v36-36zm43 36.2a2.2 2.2 0 002.2-2.2V41a2.2 2.2 0 00-2.2-2.2v.4a1.8 1.8 0 011.8 1.8v32a1.8 1.8 0 01-1.8 1.8v.4z"
                mask="url(#path-11-inside-1_13410_9140)"
            ></path>
            <rect
                width="39"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 47 46)"
            ></rect>
            <rect
                width="28"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 47 54)"
            ></rect>
            <rect
                width="35"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 47 62)"
            ></rect>
            <rect
                width="21"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 47 69)"
            ></rect>
            <path
                fill="#E7E8EF"
                d="M0 0H75V0.2H0z"
                transform="matrix(1 0 0 -1 16 34)"
            ></path>
            <path
                fill="#E7E8EF"
                d="M0 0H75V0.2H0z"
                transform="matrix(1 0 0 -1 16 78)"
            ></path>
            <rect width="9" height="9" x="19" y="21" fill="#fff" rx="1"></rect>
            <path
                fill="#F26C4F"
                d="M20.674 27.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM22.6 25.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#F26C4F"
                d="M24.757 22.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V24.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function SuccessModal() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="75"
                height="69"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 16 88)"
            ></rect>
            <rect
                width="67"
                height="6"
                fill="#00C969"
                rx="1"
                transform="matrix(1 0 0 -1 20 83)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 48)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 52)"
            ></rect>
            <rect
                width="48.921"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 56)"
            ></rect>
            <rect
                width="67"
                height="8"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 67)"
            ></rect>
            <rect
                width="53.175"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 22.127 64)"
            ></rect>
            <path
                fill="#0466C8"
                d="M50.28 41v-2.46h-.89v-.384h2.237v.383h-.899V41h-.449zm1.679-2.453v-.39h.426v.39h-.426zM51.957 41v-2.004h.428V41h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V41h-.435zm1.392-1.227h1.036a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.328 0-.588-.096-.78-.287-.19-.192-.286-.444-.286-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.538-.145.93.93 0 01.396.08.678.678 0 01.277.221c.07.094.123.203.158.326.036.123.053.258.053.406a.462.462 0 01-.01.09h-1.425c.008.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect width="9" height="9" x="49" y="24" fill="#fff" rx="1"></rect>
            <path
                fill="#00C969"
                d="M50.675 30.604l-.006.006a1.856 1.856 0 01-.153-.6c.02.219.078.417.159.594zM52.6 28.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#00C969"
                d="M54.757 25.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V27.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function UnsuccessfulModal() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="75"
                height="69"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 16 88)"
            ></rect>
            <rect
                width="67"
                height="6"
                fill="#F26C4F"
                rx="1"
                transform="matrix(1 0 0 -1 20 83)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 48)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 52)"
            ></rect>
            <rect
                width="48.921"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 56)"
            ></rect>
            <rect
                width="67"
                height="8"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 67)"
            ></rect>
            <rect
                width="53.175"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 22.127 64)"
            ></rect>
            <path
                fill="#0466C8"
                d="M50.28 41v-2.46h-.89v-.384h2.237v.383h-.899V41h-.449zm1.679-2.453v-.39h.426v.39h-.426zM51.957 41v-2.004h.428V41h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V41h-.435zm1.392-1.227h1.036a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.328 0-.588-.096-.78-.287-.19-.192-.286-.444-.286-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.538-.145.93.93 0 01.396.08.678.678 0 01.277.221c.07.094.123.203.158.326.036.123.053.258.053.406a.462.462 0 01-.01.09h-1.425c.008.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect width="9" height="9" x="49" y="24" fill="#fff" rx="1"></rect>
            <path
                fill="#F26C4F"
                d="M50.675 30.604l-.006.006a1.856 1.856 0 01-.153-.6c.02.219.078.417.159.594zM52.6 28.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#F26C4F"
                d="M54.757 25.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V27.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function TermsAndConditions() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="66"
                height="89"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 20 96)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 22)"
            ></rect>
            <path
                fill="#0466C8"
                d="M23.28 14v-2.46h-.89v-.384h2.237v.383h-.898V14h-.45zm1.679-2.453v-.39h.426v.39h-.426zM24.957 14v-2.004h.428V14h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.547v.293h-.547v1.018c0 .082.007.146.021.191.014.044.044.08.09.106a.41.41 0 00.164.048c.064.007.157.01.28.01v.336zm.477.002v-2.87h.435V14h-.435zm1.392-1.227h1.036a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.328 0-.588-.096-.78-.287-.19-.192-.286-.444-.286-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.537-.145.93.93 0 01.397.08.678.678 0 01.277.221c.07.094.123.203.159.326.035.123.052.258.052.407a.462.462 0 01-.01.09h-1.425c.008.205.07.36.185.464a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 26)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 30)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 34)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 38)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 42)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 46)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 50)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 54)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 58)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 62)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 66)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 70)"
            ></rect>
            <rect
                width="42"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 22 74)"
            ></rect>
            <path
                stroke="#E7E8EF"
                strokeWidth="0.2"
                d="M22 16.9L84 16.9"
            ></path>
            <path
                stroke="#E7E8EF"
                strokeWidth="0.2"
                d="M22 85.9L84 85.9"
            ></path>
            <rect
                width="12"
                height="4"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 72 93)"
            ></rect>
            <rect
                width="11.7"
                height="3.7"
                x="0.15"
                y="-0.15"
                fill="#fff"
                stroke="#718294"
                strokeWidth="0.3"
                rx="0.85"
                transform="matrix(1 0 0 -1 58 92.7)"
            ></rect>
        </svg>
    );
}

// TABLE
export function PricingTable() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="78"
                height="55"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 14 79)"
            ></rect>
            <rect
                width="23.8"
                height="38.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 16 70.8)"
            ></rect>
            <rect
                width="12"
                height="3"
                fill="#0466C8"
                rx="1.5"
                transform="matrix(1 0 0 -1 22 69)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 18 43)"
            ></rect>
            <path
                fill="#0466C8"
                d="M24.459 35.494a.601.601 0 00-.309.111.295.295 0 00-.115.247c0 .115.027.202.08.26.054.057.168.116.344.179v-.797zm.18-.389c.205.01.37.04.494.094.125.052.236.126.334.22l-.23.302c-.15-.142-.348-.219-.598-.23v.857a5.175 5.175 0 00.11.037c.287.097.485.209.595.334.11.123.164.299.164.525 0 .126-.023.24-.069.34a.63.63 0 01-.191.242.98.98 0 01-.275.149 1.319 1.319 0 01-.334.066v.371h-.18v-.367a1.665 1.665 0 01-.54-.102 1.072 1.072 0 01-.376-.222l.195-.324c.08.065.188.124.326.177.139.052.27.08.395.086v-.922l-.156-.05a1.948 1.948 0 01-.418-.184.7.7 0 01-.242-.256.776.776 0 01-.086-.379c0-.236.083-.42.25-.55.168-.132.385-.203.652-.214v-.285h.18v.285zm0 2.545c.261-.037.392-.175.392-.412a.587.587 0 00-.013-.138.29.29 0 00-.055-.108.387.387 0 00-.12-.1 1.37 1.37 0 00-.204-.091v.85z"
            ></path>
            <rect
                width="7"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 27 38)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 47)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 23 51)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 21 55)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 18 59)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 21 63)"
            ></rect>
            <rect
                width="23.8"
                height="38.8"
                x="0.1"
                y="-0.1"
                fill="#0466C8"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 41 70.8)"
            ></rect>
            <rect
                width="12"
                height="3"
                fill="#fff"
                rx="1.5"
                transform="matrix(1 0 0 -1 47 69)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 43 43)"
            ></rect>
            <path
                fill="#fff"
                d="M49.459 35.494a.601.601 0 00-.309.111.295.295 0 00-.115.247c0 .115.027.202.08.26.054.057.168.116.344.179v-.797zm.18-.389c.205.01.37.04.494.094.125.052.236.126.334.22l-.23.302c-.15-.142-.348-.219-.598-.23v.857a5.175 5.175 0 00.11.037c.287.097.485.209.595.334.11.123.164.299.164.525 0 .126-.023.24-.069.34a.63.63 0 01-.191.242.98.98 0 01-.275.149 1.319 1.319 0 01-.334.066v.371h-.18v-.367a1.665 1.665 0 01-.54-.102 1.072 1.072 0 01-.376-.222l.195-.324c.08.065.188.124.327.177.138.052.269.08.394.086v-.922l-.156-.05a1.948 1.948 0 01-.418-.184.7.7 0 01-.242-.256.776.776 0 01-.086-.379c0-.236.083-.42.25-.55.168-.132.385-.203.652-.214v-.285h.18v.285zm0 2.545c.261-.037.392-.175.392-.412a.587.587 0 00-.013-.138.29.29 0 00-.055-.108.387.387 0 00-.12-.1 1.37 1.37 0 00-.204-.091v.85z"
            ></path>
            <rect
                width="7"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 52 38)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 45 47)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 48 51)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 46 55)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 43 59)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 46 63)"
            ></rect>
            <rect
                width="23.8"
                height="38.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 66 70.8)"
            ></rect>
            <rect
                width="12"
                height="3"
                fill="#0466C8"
                rx="1.5"
                transform="matrix(1 0 0 -1 72 69)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 68 43)"
            ></rect>
            <path
                fill="#0466C8"
                d="M74.459 35.494a.601.601 0 00-.309.111.295.295 0 00-.115.247c0 .115.027.202.08.26.054.057.168.116.344.179v-.797zm.18-.389c.205.01.37.04.494.094.125.052.236.126.334.22l-.23.302c-.15-.142-.348-.219-.598-.23v.857a5.175 5.175 0 00.11.037c.287.097.485.209.595.334.11.123.164.299.164.525 0 .126-.023.24-.069.34a.63.63 0 01-.191.242.98.98 0 01-.275.149 1.319 1.319 0 01-.334.066v.371h-.18v-.367a1.665 1.665 0 01-.54-.102 1.072 1.072 0 01-.376-.222l.195-.324c.08.065.188.124.326.177.139.052.27.08.395.086v-.922l-.156-.05a1.948 1.948 0 01-.418-.184.7.7 0 01-.242-.256.776.776 0 01-.086-.379c0-.236.083-.42.25-.55.168-.132.385-.203.652-.214v-.285h.18v.285zm0 2.545c.261-.037.392-.175.392-.412a.587.587 0 00-.013-.138.29.29 0 00-.055-.108.387.387 0 00-.12-.1 1.37 1.37 0 00-.204-.091v.85z"
            ></path>
            <rect
                width="7"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 77 38)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 70 47)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 73 51)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 55)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 68 59)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 71 63)"
            ></rect>
        </svg>
    );
}

export function TableList() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="78"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 97)"
            ></rect>
            <rect
                width="95.8"
                height="7.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 5 28.8)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 7 26)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 19 26)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 31 26)"
            ></rect>
            <rect
                width="95.8"
                height="7.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 5 38.8)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 7 36)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 19 36)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 31 36)"
            ></rect>
            <rect
                width="95.8"
                height="7.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 5 48.8)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 7 46)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 19 46)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 31 46)"
            ></rect>
            <rect
                width="95.8"
                height="7.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 5 58.8)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 7 56)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 19 56)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 31 56)"
            ></rect>
            <rect
                width="95.8"
                height="7.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 5 68.8)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 7 66)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 19 66)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 31 66)"
            ></rect>
            <rect
                width="95.8"
                height="7.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 5 78.8)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 7 76)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 19 76)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 31 76)"
            ></rect>
            <rect
                width="100"
                height="14"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 17)"
            ></rect>
            <rect
                width="14"
                height="5"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 86 13)"
            ></rect>
            <rect
                width="22"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 7 9)"
            ></rect>
            <rect
                width="60"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 7 13)"
            ></rect>
        </svg>
    );
}

export function ComparisonTable() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="102"
                height="67"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 2 79)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 4 33)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 4 37)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 4 41)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 4 45)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 4 49)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 4 53)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 4 57)"
            ></rect>
            <rect
                width="23.8"
                height="38.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 26 64.8)"
            ></rect>
            <rect
                width="12"
                height="3"
                fill="#0466C8"
                rx="1.5"
                transform="matrix(1 0 0 -1 32 63)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 28 37)"
            ></rect>
            <path
                fill="#0466C8"
                d="M34.459 29.494a.601.601 0 00-.309.111.295.295 0 00-.115.247c0 .115.027.202.08.26.054.057.168.117.344.179v-.797zm.18-.389c.205.01.37.04.494.094.125.052.236.126.334.22l-.23.302c-.15-.142-.348-.219-.598-.23v.857a5.175 5.175 0 00.11.037c.287.097.485.209.595.334.11.123.164.299.164.525 0 .126-.023.24-.069.34a.63.63 0 01-.191.242.98.98 0 01-.275.149 1.319 1.319 0 01-.334.066v.371h-.18v-.367a1.665 1.665 0 01-.54-.102 1.072 1.072 0 01-.376-.222l.195-.325c.08.066.188.125.327.178.138.052.269.08.394.086v-.922l-.156-.05a1.948 1.948 0 01-.418-.184.7.7 0 01-.242-.256.776.776 0 01-.086-.379c0-.235.083-.42.25-.55.168-.132.385-.203.652-.213v-.286h.18v.285zm0 2.545c.261-.037.392-.175.392-.412a.587.587 0 00-.013-.138.29.29 0 00-.055-.108.387.387 0 00-.12-.1 1.37 1.37 0 00-.204-.091v.85z"
            ></path>
            <rect
                width="7"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 37 32)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 30 41)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 33 45)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 31 49)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 28 53)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 31 57)"
            ></rect>
            <rect
                width="23.8"
                height="38.8"
                x="0.1"
                y="-0.1"
                fill="#0466C8"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 51 64.8)"
            ></rect>
            <rect
                width="12"
                height="3"
                fill="#fff"
                rx="1.5"
                transform="matrix(1 0 0 -1 57 63)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 53 37)"
            ></rect>
            <path
                fill="#fff"
                d="M59.459 29.494a.601.601 0 00-.309.111.295.295 0 00-.115.247c0 .115.027.202.08.26.054.057.168.117.344.179v-.797zm.18-.389c.205.01.37.04.494.094.125.052.236.126.334.22l-.23.302c-.15-.142-.348-.219-.598-.23v.857a5.175 5.175 0 00.11.037c.287.097.485.209.595.334.11.123.164.299.164.525 0 .126-.023.24-.069.34a.63.63 0 01-.191.242.98.98 0 01-.275.149 1.319 1.319 0 01-.334.066v.371h-.18v-.367a1.665 1.665 0 01-.54-.102 1.072 1.072 0 01-.376-.222l.195-.325c.08.066.188.125.327.178.138.052.269.08.394.086v-.922l-.156-.05a1.948 1.948 0 01-.418-.184.7.7 0 01-.242-.256.776.776 0 01-.086-.379c0-.235.083-.42.25-.55.168-.132.385-.203.652-.213v-.286h.18v.285zm0 2.545c.261-.037.392-.175.392-.412a.587.587 0 00-.013-.138.29.29 0 00-.055-.108.387.387 0 00-.12-.1 1.37 1.37 0 00-.204-.091v.85z"
            ></path>
            <rect
                width="7"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 62 32)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 55 41)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 58 45)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 56 49)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 53 53)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#fff"
                rx="1"
                transform="matrix(1 0 0 -1 56 57)"
            ></rect>
            <rect
                width="23.8"
                height="38.8"
                x="0.1"
                y="-0.1"
                fill="#fff"
                stroke="#E7E8EF"
                strokeWidth="0.2"
                rx="1.9"
                transform="matrix(1 0 0 -1 76 64.8)"
            ></rect>
            <rect
                width="12"
                height="3"
                fill="#0466C8"
                rx="1.5"
                transform="matrix(1 0 0 -1 82 63)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 78 37)"
            ></rect>
            <path
                fill="#0466C8"
                d="M84.459 29.494a.601.601 0 00-.309.111.295.295 0 00-.115.247c0 .115.027.202.08.26.054.057.168.117.344.179v-.797zm.18-.389c.205.01.37.04.494.094.125.052.236.126.334.22l-.23.302c-.15-.142-.348-.219-.598-.23v.857a5.175 5.175 0 00.11.037c.287.097.485.209.595.334.11.123.164.299.164.525 0 .126-.023.24-.069.34a.63.63 0 01-.191.242.98.98 0 01-.275.149 1.319 1.319 0 01-.334.066v.371h-.18v-.367a1.665 1.665 0 01-.54-.102 1.072 1.072 0 01-.376-.222l.195-.325c.08.066.188.125.326.178.139.052.27.08.395.086v-.922l-.156-.05a1.948 1.948 0 01-.418-.184.7.7 0 01-.242-.256.776.776 0 01-.086-.379c0-.235.083-.42.25-.55.168-.132.385-.203.652-.213v-.286h.18v.285zm0 2.545c.261-.037.392-.175.392-.412a.587.587 0 00-.013-.138.29.29 0 00-.055-.108.387.387 0 00-.12-.1 1.37 1.37 0 00-.204-.091v.85z"
            ></path>
            <rect
                width="7"
                height="2"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 87 32)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 80 41)"
            ></rect>
            <rect
                width="10"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 83 45)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 81 49)"
            ></rect>
            <rect
                width="20"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 78 53)"
            ></rect>
            <rect
                width="15"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 81 57)"
            ></rect>
        </svg>
    );
}

// Footer
export function FooterBasic() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="27"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 66)"
            ></rect>
            <rect
                width="26"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 6 55)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 44 46)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 64 46)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 83 46)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 58)"
            ></rect>
            <rect
                width="29"
                height="1"
                fill="#E7E8EF"
                rx="0.5"
                transform="matrix(1 0 0 -1 39 64)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 44 50)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 50)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 83 50)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 44 53)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 53)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 83 53)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 44 56)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 56)"
            ></rect>
            <rect width="9" height="9" x="6" y="43" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M7.675 49.604l-.006.006a1.856 1.856 0 01-.153-.6c.02.219.078.417.159.594zM9.6 47.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M11.757 44.5H9.243c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V46.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function FooterWithBlogTitle() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="15"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 59)"
            ></rect>
            <rect
                width="17"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 83 51)"
            ></rect>
            <rect
                width="26"
                height="2"
                x="42"
                y="51"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="rotate(-180 42 51)"
            ></rect>
            <rect
                width="11"
                height="2"
                x="27"
                y="54"
                fill="#E7E8EF"
                rx="1"
                transform="rotate(-180 27 54)"
            ></rect>
            <rect
                width="9"
                height="9"
                fill="#fff"
                rx="1"
                transform="matrix(-1 0 0 1 15 47)"
            ></rect>
            <path
                fill="#AAB4BF"
                d="M13.325 53.604l.006.006c.081-.177.132-.378.153-.6a1.843 1.843 0 01-.159.594zM11.4 51.014a.714.714 0 110-1.428.714.714 0 010 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M9.243 48.5h2.514c1.092 0 1.743.651 1.743 1.743v2.514c0 .327-.057.612-.168.852-.258.57-.81.891-1.575.891H9.243c-1.092 0-1.743-.651-1.743-1.743V50.243c0-1.092.651-1.743 1.743-1.743zm-1.254 3.15a.669.669 0 01.846 0l1.248 1.071a.669.669 0 00.846 0l.102-.084a.666.666 0 01.792-.042l1.122.753a1.6 1.6 0 00.105-.591v-2.514c0-.846-.447-1.293-1.293-1.293H9.243c-.846 0-1.293.447-1.293 1.293v1.44l.039-.033z"
            ></path>
        </svg>
    );
}

export function FooterWithGetAppButton() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="27"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 66)"
            ></rect>
            <rect
                width="26"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 6 55)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 44 46)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 64 46)"
            ></rect>
            <rect
                width="12"
                height="5.5"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 86 49)"
            ></rect>
            <rect
                width="6"
                height="1"
                x="90"
                y="46"
                fill="#fff"
                rx="0.5"
            ></rect>
            <path
                fill="#000"
                fillRule="evenodd"
                d="M88.85 47.145c.07-.113.096-.17.15-.297-.397-.157-.46-.748-.068-.975a.584.584 0 00-.447-.248.647.647 0 00-.264.06.47.47 0 01-.18.044c-.072 0-.135-.023-.202-.048a.664.664 0 00-.245-.056c-.178 0-.368.113-.489.308-.17.275-.14.79.134 1.23.098.158.23.334.4.337.072.001.118-.022.17-.045.058-.028.122-.058.233-.058.11-.001.173.03.232.058.05.023.095.046.166.045.173-.003.311-.198.41-.355zM88.46 45a.52.52 0 01-.105.369.422.422 0 01-.333.177.479.479 0 01.107-.36c.08-.1.215-.177.331-.186z"
                clipRule="evenodd"
            ></path>
            <rect
                width="12"
                height="5.5"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 86 56)"
            ></rect>
            <rect
                width="6"
                height="1"
                x="90"
                y="53"
                fill="#fff"
                rx="0.5"
            ></rect>
            <path
                fill="#000"
                d="M89.426 53.411l-.348.197c-.024.014-.052.008-.073-.013l-.233-.264a.077.077 0 010-.1l.237-.27a.057.057 0 01.073-.012l.344.195c.099.054.099.212 0 .267zM88.789 52.78c.038.02.046.079.016.113l-.209.236-.089.1a.057.057 0 01-.089 0l-.892-1.01c-.05-.056.008-.148.072-.113l1.19.674zM87 54.428v-2.357c0-.062.066-.095.106-.05l1.097 1.203a.077.077 0 01-.001.103l-1.097 1.154c-.04.042-.105.01-.105-.053zM88.784 53.774l-1.174.664c-.064.036-.123-.056-.073-.113l.882-.997a.057.057 0 01.089 0l.294.333c.028.034.02.092-.018.113z"
            ></path>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 58)"
            ></rect>
            <rect
                width="29"
                height="1"
                fill="#E7E8EF"
                rx="0.5"
                transform="matrix(1 0 0 -1 39 64)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 44 50)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 50)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 44 53)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 53)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 44 56)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 56)"
            ></rect>
            <rect width="9" height="9" x="6" y="43" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M7.675 49.604l-.006.006a1.856 1.856 0 01-.153-.6c.02.219.078.417.159.594zM9.6 47.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M11.757 44.5H9.243c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V46.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function FooterWithLinks() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="100"
                height="27"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 66)"
            ></rect>
            <rect
                width="21"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 6 55)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 58)"
            ></rect>
            <rect
                width="29"
                height="1"
                fill="#E7E8EF"
                rx="0.5"
                transform="matrix(1 0 0 -1 39 64)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 70 46)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 70 50)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 70 53)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 88 46)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 88 50)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 88 53)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 34 46)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 34 50)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 34 53)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 34 56)"
            ></rect>
            <rect
                width="12"
                height="2"
                fill="#718294"
                fillOpacity="0.4"
                rx="1"
                transform="matrix(1 0 0 -1 52 46)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 52 50)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 52 53)"
            ></rect>
            <rect
                width="11"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 52 56)"
            ></rect>
            <rect width="9" height="9" x="6" y="43" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M7.675 49.604l-.006.006a1.856 1.856 0 01-.153-.6c.02.219.078.417.159.594zM9.6 47.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M11.757 44.5H9.243c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V46.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function OTP() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 90)"
            ></rect>
            <rect
                width="30"
                height="3"
                fill="#E7E8EF"
                rx="1.5"
                transform="matrix(1 0 0 -1 6 12)"
            ></rect>
            <rect
                width="100"
                height="56"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 3 78)"
            ></rect>
            <rect
                width="18"
                height="20"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 19 75)"
            ></rect>
            <rect
                width="17.8"
                height="19.8"
                x="0.1"
                y="-0.1"
                stroke="#A8ABBB"
                strokeDasharray="0.4 0.4"
                strokeOpacity="0.41"
                strokeWidth="0.2"
                rx="2.9"
                transform="matrix(1 0 0 -1 19 74.8)"
            ></rect>
            <path
                stroke="#A8ABBB"
                strokeDasharray="0.5 0.5"
                strokeOpacity="0.4"
                strokeWidth="0.2"
                d="M19.833 74.584L36.5 55.834M36.5 74.584l-16.667-18.75"
            ></path>
            <rect
                width="3.75"
                height="3.75"
                x="26.5"
                y="63.334"
                fill="#fff"
                rx="1"
            ></rect>
            <path
                fill="#AAB4BF"
                d="M27.198 66.085l-.003.002a.773.773 0 01-.064-.25.767.767 0 00.067.248zM28 65.006a.298.298 0 100-.595.298.298 0 000 .595z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M28.899 63.959H27.85c-.455 0-.726.27-.726.726v1.047a.84.84 0 00.07.355c.107.238.337.371.656.371H28.9c.455 0 .726-.27.726-.726v-1.047c0-.455-.271-.727-.726-.727zm.522 1.312a.279.279 0 00-.352 0l-.52.446a.279.279 0 01-.353 0l-.042-.035a.277.277 0 00-.33-.017l-.468.313a.667.667 0 01-.044-.246v-1.047c0-.353.187-.539.54-.539h1.047c.352 0 .538.186.538.539v.6l-.016-.014z"
            ></path>
            <path
                fill="#fff"
                d="M53 78h47a3 3 0 003-3V25a3 3 0 00-3-3H53v56z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M53 78h50-50zm50-56H53h50zm-50.075 0v56h.15V22h-.15zM103 78V22v56z"
            ></path>
            <rect width="9" height="9" x="74" y="30" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M75.674 36.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM77.6 34.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M79.757 31.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V33.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
            <path
                fill="#0466C8"
                d="M75.28 45v-2.46h-.89v-.384h2.237v.383h-.898V45h-.45zm1.679-2.453v-.39h.426v.39h-.426zM76.957 45v-2.004h.428V45h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V45h-.435zm1.393-1.227h1.035a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.329 0-.589-.096-.78-.287-.192-.192-.287-.444-.287-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.538-.145.93.93 0 01.396.08.678.678 0 01.277.221c.07.094.123.203.159.326.035.123.052.258.052.406a.462.462 0 01-.01.09h-1.425c.007.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect
                width="42"
                height="2"
                x="8"
                y="31"
                fill="#E7E8EF"
                rx="1"
            ></rect>
            <rect
                width="42"
                height="2"
                x="8"
                y="34"
                fill="#E7E8EF"
                rx="1"
            ></rect>
            <rect
                width="28"
                height="2"
                x="8"
                y="37"
                fill="#E7E8EF"
                rx="1"
            ></rect>
            <rect
                width="20"
                height="2"
                x="8"
                y="27"
                fill="#E7E8EF"
                rx="1"
            ></rect>
            <rect
                width="7"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 64 55)"
            ></rect>
            <rect
                width="7"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 72 55)"
            ></rect>
            <rect
                width="7"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 80 55)"
            ></rect>
            <rect
                width="7"
                height="4"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 88 55)"
            ></rect>
            <rect
                width="3"
                height="1"
                fill="#FFE7DD"
                rx="0.5"
                transform="matrix(1 0 0 -1 92 58)"
            ></rect>
            <rect
                width="7"
                height="1"
                fill="#E7E8EF"
                rx="0.5"
                transform="matrix(1 0 0 -1 84 58)"
            ></rect>
            <rect
                width="30"
                height="4"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 64 67)"
            ></rect>
        </svg>
    );
}

export function Redirect() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="75"
                height="69"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 16 88)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 59)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 63)"
            ></rect>
            <rect
                width="48.921"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 67)"
            ></rect>
            <path
                fill="#0466C8"
                d="M50.28 51v-2.46h-.89v-.384h2.237v.383h-.899V51h-.449zm1.679-2.453v-.39h.426v.39h-.426zM51.957 51v-2.004h.428V51h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V51h-.435zm1.392-1.227h1.036a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.328 0-.588-.096-.78-.287-.19-.192-.286-.444-.286-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.538-.145.93.93 0 01.396.08.678.678 0 01.277.221c.07.094.123.203.158.326.036.123.053.258.053.406a.462.462 0 01-.01.09h-1.425c.008.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect width="9" height="9" x="49" y="34" fill="#fff" rx="1"></rect>
            <path
                stroke="#AAB4BF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="0.5"
                d="M55.545 39.546l-.912.912M52.455 39.546h3.09M52.455 38.455l.912-.913M55.545 38.454h-3.09"
            ></path>
            <path
                stroke="#AAB4BF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
                d="M54 42a3 3 0 100-6 3 3 0 000 6z"
            ></path>
        </svg>
    );
}

export function TechnicalIssue() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="75"
                height="69"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 16 88)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 59)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 63)"
            ></rect>
            <rect
                width="48.921"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 67)"
            ></rect>
            <path
                fill="#0466C8"
                d="M50.28 51v-2.46h-.89v-.384h2.237v.383h-.899V51h-.449zm1.679-2.453v-.39h.426v.39h-.426zM51.957 51v-2.004h.428V51h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V51h-.435zm1.392-1.227h1.036a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.328 0-.588-.096-.78-.287-.19-.192-.286-.444-.286-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.538-.145.93.93 0 01.396.08.678.678 0 01.277.221c.07.094.123.203.158.326.036.123.053.258.053.406a.462.462 0 01-.01.09h-1.425c.008.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect width="9" height="9" x="49" y="34" fill="#fff" rx="1"></rect>
            <path
                stroke="#AAB4BF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
                d="M51 37.873v1.545c0 .567 0 .567.556.929l1.527.85a.95.95 0 00.834 0l1.527-.85c.556-.362.556-.362.556-.926v-1.547c0-.565 0-.565-.556-.927l-1.527-.85a.949.949 0 00-.834 0l-1.527.85c-.556.362-.556.362-.556.926z"
            ></path>
            <path
                stroke="#AAB4BF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
                d="M53.5 39.45c.46 0 .833-.36.833-.803 0-.443-.373-.803-.833-.803-.46 0-.833.36-.833.803 0 .444.373.803.833.803z"
            ></path>
        </svg>
    );
}

export function Completion() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="75"
                height="69"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 16 88)"
            ></rect>
            <rect
                width="32"
                height="6"
                fill="#0466C8"
                rx="1"
                transform="matrix(1 0 0 -1 38 73)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 54)"
            ></rect>
            <rect
                width="67"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 58)"
            ></rect>
            <rect
                width="48.921"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 20 62)"
            ></rect>
            <path
                fill="#0466C8"
                d="M50.28 46v-2.46h-.89v-.384h2.237v.383h-.899V46h-.449zm1.679-2.453v-.39h.426v.39h-.426zM51.957 46v-2.004h.428V46h-.428zm2.154-.002h-.187c-.143 0-.261-.01-.354-.027a.63.63 0 01-.246-.104.429.429 0 01-.156-.219 1.197 1.197 0 01-.047-.367v-.992h-.398v-.293h.41v-.488l.424-.127v.615h.546v.293h-.546v1.018c0 .082.007.145.021.191.014.044.044.08.09.105a.41.41 0 00.164.05c.064.006.157.01.28.01v.335zm.477.002v-2.87h.435V46h-.435zm1.392-1.227h1.036a.576.576 0 00-.153-.36.436.436 0 00-.322-.126.543.543 0 00-.37.129.617.617 0 00-.19.357zm.6 1.272c-.328 0-.588-.096-.78-.287-.19-.192-.286-.444-.286-.758 0-.194.04-.37.119-.53a.925.925 0 01.351-.38.996.996 0 01.538-.145.93.93 0 01.396.08.678.678 0 01.277.221c.07.094.123.203.158.326.036.123.053.258.053.406a.462.462 0 01-.01.09h-1.425c.008.206.07.361.185.465a.658.658 0 00.457.157c.228 0 .438-.073.63-.22l.122.321a1.27 1.27 0 01-.785.254z"
            ></path>
            <rect width="9" height="9" x="49" y="29" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M50.674 35.604l-.006.006a1.856 1.856 0 01-.153-.6c.021.219.078.417.16.594zM52.6 33.014a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M54.757 30.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V32.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
        </svg>
    );
}

export function NoData() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <rect
                width="66"
                height="54"
                fill="#fff"
                rx="3"
                transform="matrix(1 0 0 -1 21 78)"
            ></rect>
            <rect width="9" height="9" x="50" y="39" fill="#fff" rx="1"></rect>
            <path
                fill="#AAB4BF"
                d="M51.675 45.604l-.006.006a1.856 1.856 0 01-.153-.6c.02.22.078.417.159.594zM53.6 43.013a.714.714 0 100-1.428.714.714 0 000 1.428z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M55.757 40.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V42.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591v-2.514c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
            ></path>
            <rect
                width="31"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 39 54)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 23 60)"
            ></rect>
            <rect
                width="62"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 23 63)"
            ></rect>
        </svg>
    );
}

export function FAQ() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="106"
            height="102"
            fill="none"
            viewBox="0 0 106 102"
        >
            <rect width="106" height="102" fill="#E7E8EF" rx="2"></rect>
            <mask id="path-2-inside-1_14593_8327" fill="#fff">
                <path d="M2 94a3 3 0 003 3h96a3 3 0 003-3V19H2v75z"></path>
            </mask>
            <path
                fill="#fff"
                d="M2 94a3 3 0 003 3h96a3 3 0 003-3V19H2v75z"
            ></path>
            <path
                fill="#AAB4BF"
                d="M2 97h102H2zm102-78.15H2v.3h102v-.3zM2 19v78-78zm102 78V19v78z"
                mask="url(#path-2-inside-1_14593_8327)"
            ></path>
            <rect
                width="94"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 24)"
            ></rect>
            <rect
                width="94"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 36)"
            ></rect>
            <rect
                width="94"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 48)"
            ></rect>
            <rect
                width="94"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 60)"
            ></rect>
            <rect
                width="94"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 72)"
            ></rect>
            <rect
                width="64"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 28)"
            ></rect>
            <rect
                width="64"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 40)"
            ></rect>
            <rect
                width="64"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 52)"
            ></rect>
            <rect
                width="64"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 64)"
            ></rect>
            <rect
                width="64"
                height="2"
                fill="#E7E8EF"
                rx="1"
                transform="matrix(1 0 0 -1 6 76)"
            ></rect>
            <path
                fill="#fff"
                d="M2 19h102V5a3 3 0 00-3-3H5a3 3 0 00-3 3v14z"
            ></path>
            <g opacity="0.4">
                <rect
                    width="97"
                    height="13"
                    fill="#fff"
                    rx="3"
                    transform="matrix(1 0 0 -1 4 17)"
                ></rect>
                <rect
                    width="96.8"
                    height="12.8"
                    x="0.1"
                    y="-0.1"
                    stroke="#A8ABBB"
                    strokeDasharray="0.4 0.4"
                    strokeOpacity="0.41"
                    strokeWidth="0.2"
                    rx="2.9"
                    transform="matrix(1 0 0 -1 4 16.8)"
                ></rect>
                <path
                    stroke="#A8ABBB"
                    strokeDasharray="0.5 0.5"
                    strokeOpacity="0.4"
                    strokeWidth="0.2"
                    d="M6.818 16L99 5.167M99 16L6.819 5.167"
                ></path>
                <rect
                    width="9"
                    height="9"
                    x="48"
                    y="6"
                    fill="#fff"
                    rx="1"
                ></rect>
                <path
                    fill="#AAB4BF"
                    d="M49.675 12.604l-.006.006a1.856 1.856 0 01-.153-.6c.02.22.078.417.159.594zM51.6 10.013a.714.714 0 100-1.428.714.714 0 000 1.428z"
                ></path>
                <path
                    fill="#AAB4BF"
                    d="M53.757 7.5h-2.514c-1.092 0-1.743.651-1.743 1.743v2.514c0 .327.057.612.168.852.258.57.81.891 1.575.891h2.514c1.092 0 1.743-.651 1.743-1.743V9.243c0-1.092-.651-1.743-1.743-1.743zm1.254 3.15a.669.669 0 00-.846 0l-1.248 1.071a.669.669 0 01-.846 0l-.102-.084a.666.666 0 00-.792-.042l-1.122.753a1.6 1.6 0 01-.105-.591V9.243c0-.846.447-1.293 1.293-1.293h2.514c.846 0 1.293.447 1.293 1.293v1.44l-.039-.033z"
                ></path>
            </g>
        </svg>
    );
}
